import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { WebcastModel } from 'rev-portal/scheduledEvents/webcast/model/WebcastModel';
import { UserContextService, IUserContextUser } from 'rev-shared/security/UserContext.Service';

import styles from './ProducerWebcast.module.less';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
	selector: 'producer-setup',
	templateUrl: './ProducerSetup.Component.html',
	host: { '[class]': 'styles.setupRoot' },
	standalone: false
})
export class ProducerSetupComponent implements OnInit {
	@Input() public webcast: WebcastModel;
	@Output() public goBackstage = new EventEmitter<any>();

	public learnMoreModalRef: BsModalRef;
	public modalOpen: boolean;
	public user: IUserContextUser;
	public readonly styles = styles;

	constructor(
		private readonly UserContextService: UserContextService,
		private readonly modalService: BsModalService
	) {}

	public ngOnInit(): void {
		this.user = this.UserContextService.getUser();
	}

	public showLearnMore(template: TemplateRef<any>): void {
		this.modalOpen = true;
		this.learnMoreModalRef = this.modalService.show(
			template,
			Object.assign({}, { class: `theme-primary ${styles.learnMoreModal}` })
		);

		this.learnMoreModalRef.onHide.subscribe( () => {
			this.modalOpen = false;
			this.learnMoreModalRef.onHide.unsubscribe();
		});
	}

	public submit(): void {
		this.goBackstage.emit();
	}
}
